import "core-js";
import React,{ Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import * as serviceWorker from "./serviceWorker";
import store from "./store/index"; 
import App from "./App";
import { HashRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { initTabViewOverflowWatcher } from "./utils/tabViewOverflow";
import { initTouchTooltipAutoHide } from "./utils/touchTooltipAutoHide";
import { initAlertToast } from "./utils/alertToast";
const history = createBrowserHistory();
// every alert(...) in the pages shows as a toast instead of a blocking dialog
initAlertToast();
// installs the "ResizeObserver loop" error filter before anything renders
initTabViewOverflowWatcher();
console.log( " index.tsx  = " + new Date() +" "+ window.location.pathname );
  ReactDOM.render(
  <HashRouter>
    <ScrollToTop>
      <Provider store={store}>
      <Suspense fallback={<div className="overlay-content"><div className="wrapper" /></div>}>
        <Router history={history}>
          <App />
        </Router>
        </Suspense>
      </Provider>
    </ScrollToTop>
  </HashRouter>,

  document.getElementById("root")
);
initTouchTooltipAutoHide();
 
serviceWorker.unregister();
